<div class="content" fxLayoutAlign="center center">
    <lib-ngx-image-zoom zoomMode="hover-freeze" enableScrollZoom="true" enableLens="true" lensWidth="150" lensHeight="150" circularLens="true"
                    [thumbImage]="(pictureUrl.medium | picture)"
                    [fullImage]="(pictureUrl.large | picture)"
    ></lib-ngx-image-zoom>
</div>
<span class="close-button button" (click)="onClose()"><mat-icon>close</mat-icon></span>
